import {
  Box,
  FormControlLabel,
  Typography,
  Paper,
} from "@mui/material";
import { useState } from "react";
import Switch from "react-switch";

import { Flex } from "@semcore/flex-box";
import { Text } from "@semcore/typography";
import Input from "@semcore/input";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import TrashM from "@semcore/ui/icon/Trash/m";
import EditM from "@semcore/ui/icon/Edit/m";
import MathPlusM from "@semcore/ui/icon/MathPlus/m";
import Button from "@semcore/button";

import { validateCustomLink } from "./helper";
import AddProjectStore from "../../../../store/AddProjectStore";

const footerLinks = [
  {
    label: "Copyright 2025",
    url: "",
  },
  {
    label: "All rights reserved",
    url: "",
  },
  {
    label: "Privacy Policy",
    url: "https://www.rankspro.io/privacy",
  },
  {
    label: "Refund Policy",
    url: "https://www.rankspro.io/refund-policy",
  },
  {
    label: "Terms",
    url: "https://www.rankspro.io/terms",
  },
];

const FooterLinks = () => {
  const { white_lable } = AddProjectStore((state) => state);
  const [customLink, setCustomLink] = useState({
    id: 1,
    label: "",
    url: "",
  });
  const [error, setError] = useState({
    id: null,
    label: "",
    url: "",
  });

  const handleToggleFooterSetting = (key) => {
    AddProjectStore.setState((state) => ({
      white_lable: {
        ...state.white_lable,
        isUpdate: true,
        [key]: !state.white_lable?.[key],
      },
    }));
  };

  const handleEditCustomLink = (newLink) => {
    setCustomLink(newLink);
    deleteCustomLink(newLink.id);
  };

  const deleteCustomLink = (linkId) => {
    AddProjectStore.setState((state) => ({
      white_lable: {
        ...state.white_lable,
        isUpdate: true,
        custom_links: (state.white_lable?.custom_links || []).filter(
          (link) => link.id !== linkId
        ),
      },
    }));
  };

  const handleSubmitClick = (newLink) => {
    const isError = validateCustomLink(newLink);
    if (isError.label || isError.url) {
      setError(isError);
    } else {
      AddProjectStore.setState((state) => {
        const existingLinks = state.white_lable?.custom_links || [];

        const updatedLinks = existingLinks.some(
          (link) => link.id === newLink.id
        )
          ? existingLinks.map((link) =>
              link.id === newLink.id ? newLink : link
            )
          : [...existingLinks, newLink];

        updatedLinks.sort((a, b) => a.id - b.id);

        return {
          white_lable: {
            ...state.white_lable,
            isUpdate: true,
            custom_links: updatedLinks,
          },
        };
      });
      setError({
        id: null,
        label: "",
        url: "",
      });
      setCustomLink({
        id: newLink.id + 1,
        label: "",
        url: "",
      });
    }
  };

  return (
    <Paper
      elevation={3}
      className="p-3 mt-3"
      sx={{ boxShadow: "none", border: "2px solid #C4C7CF" }}
    >
      <Typography variant="subtitle1" gutterBottom>
        2. Footer settings
      </Typography>
      <Flex
        gap={3}
        mb={3}
        w={350}
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Flex direction="column" gap={1}>
          <Text tag="label" htmlFor="header-logo" size={200}>
            Show footer links:
          </Text>
          <FormControlLabel
            value="end"
            control={
              <Switch
                className="react-switch"
                onColor="#6a3be4"
                onChange={() => handleToggleFooterSetting("show_footer_links")}
                checked={white_lable.show_footer_links || false}
                aria-labelledby="neat-label"
                uncheckedIcon={false}
                checkedIcon={false}
                width={40}
                height={20}
              />
            }
            label={white_lable.show_footer_links ? "On" : "Off"}
            labelPlacement="end"
            sx={{
              margin: 0,
              "& .MuiTypography-root": {
                marginLeft: "10px",
              },
            }}
          />
        </Flex>
        <Flex direction="column" gap={1}>
          <Text tag="label" htmlFor="header-logo" size={200}>
            Use custom links:
          </Text>
          <FormControlLabel
            value="end"
            control={
              <Switch
                className="react-switch"
                onColor="#6a3be4"
                onChange={() =>
                  handleToggleFooterSetting("show_footer_custom_links")
                }
                checked={white_lable.show_footer_custom_links || false}
                aria-labelledby="neat-label"
                uncheckedIcon={false}
                checkedIcon={false}
                width={40}
                height={20}
              />
            }
            label={white_lable.show_footer_custom_links ? "On" : "Off"}
            labelPlacement="end"
            sx={{
              margin: 0,
              "& .MuiTypography-root": {
                marginLeft: "10px",
              },
            }}
          />
        </Flex>
      </Flex>

      {white_lable.show_footer_custom_links ? (
        <Box>
          {white_lable.custom_links?.map((linkItem, index) => {
            return (
              <Flex
                gap={3}
                mb={3}
                alignItems="flex-start"
                key={`custom-link-${index}`}
              >
                <Flex direction="column" gap={1} w={200}>
                  <Text tag="label" size={200}>
                    Text shown for the link:
                  </Text>

                  <Input h={"35px"} disabled>
                    <Input.Value
                      defaultValue={linkItem.label}
                      placeholder=""
                      type="text"
                      autoComplete="off"
                    />
                  </Input>
                </Flex>
                <Flex direction="column" gap={1} w={400}>
                  <Flex gap={2} justifyContent="space-between">
                    <Text tag="label" size={200} display="flex">
                      Where should the link go:
                    </Text>
                    {linkItem?.url && (
                      <a href={linkItem?.url} target="_blank">
                        <OpenInNewIcon
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#6a3be4",
                          }}
                        />
                      </a>
                    )}
                  </Flex>
                  <Input h={"35px"} disabled>
                    <Input.Value
                      defaultValue={linkItem.url}
                      placeholder=""
                      type="text"
                      autoComplete="off"
                    />
                  </Input>
                </Flex>
                <Box className="mt-auto">
                  <Button
                    title="edit"
                    h={34}
                    w={34}
                    onClick={() => handleEditCustomLink(linkItem)}
                  >
                    <Button.Addon>
                      <EditM />
                    </Button.Addon>
                  </Button>
                  <Button
                    title="remove"
                    ml={2}
                    h={34}
                    w={34}
                    onClick={() => deleteCustomLink(linkItem.id)}
                  >
                    <Button.Addon>
                      <TrashM />
                    </Button.Addon>
                  </Button>
                </Box>
              </Flex>
            );
          })}

          {white_lable.custom_links?.length < 5 && (
            <Flex gap={3} mb={3} alignItems="flex-start">
              <Flex direction="column" gap={1} w={200}>
                <Text tag="label" size={200}>
                  Text shown for the link:
                </Text>

                <Input h={"35px"} state={error?.label ? "invalid" : "normal"}>
                  <Input.Value
                    value={customLink.label}
                    placeholder=""
                    type="text"
                    autoComplete="off"
                    onChange={(value) => {
                      setCustomLink((pre) => ({
                        ...pre,
                        label: value,
                      }));
                    }}
                  />
                </Input>
                {error.label && error.id === customLink.id ? (
                  <Text size={100} color="#ff4953">
                    {error.label}
                  </Text>
                ) : null}
              </Flex>
              <Flex direction="column" gap={1} w={400}>
                <Flex gap={2} justifyContent="space-between">
                  <Text tag="label" size={200} display="flex">
                    Where should the link go:
                  </Text>
                </Flex>
                <Flex gap={2} justifyContent="space-between">
                  <Input h={"35px"} state={error?.url ? "invalid" : "normal"}>
                    <Input.Value
                      value={customLink.url}
                      placeholder=""
                      type="url"
                      autoComplete="off"
                      onChange={(value) => {
                        setCustomLink((pre) => ({ ...pre, url: value }));
                      }}
                    />
                  </Input>

                  {customLink.label && customLink.url && (
                    <Button
                      title="add"
                      h={34}
                      w={34}
                      onClick={() => handleSubmitClick(customLink)}
                    >
                      <Button.Addon>
                        <MathPlusM />
                      </Button.Addon>
                    </Button>
                  )}
                </Flex>
                {error?.url && error.id === customLink.id ? (
                  <Text size={100} color="#ff4953">
                    {error.url}
                  </Text>
                ) : null}
              </Flex>
            </Flex>
          )}
        </Box>
      ) : white_lable.show_footer_links ? (
        <Box>
          {footerLinks?.map((linkItem) => {
            return (
              <Flex gap={3} mb={3} alignItems="center" key={linkItem.label}>
                <Flex direction="column" gap={1} w={200}>
                  <Text tag="label" size={200}>
                    Text shown for the link:
                  </Text>

                  <Input h={"35px"} disabled>
                    <Input.Value
                      value={linkItem.label}
                      placeholder=""
                      type="text"
                      autoComplete="off"
                    />
                  </Input>
                </Flex>
                <Flex direction="column" gap={1} w={400}>
                  <Flex gap={2} justifyContent="space-between">
                    <Text tag="label" size={200} display="flex">
                      Where should the link go:
                    </Text>
                    {linkItem?.url && (
                      <a href={linkItem?.url} target="_blank">
                        <OpenInNewIcon
                          sx={{
                            width: "18px",
                            height: "18px",
                            color: "#6a3be4",
                          }}
                        />
                      </a>
                    )}
                  </Flex>
                  <Input h={"35px"} disabled>
                    <Input.Value
                      value={linkItem.url}
                      placeholder=""
                      type="text"
                      autoComplete="off"
                    />
                  </Input>
                </Flex>
              </Flex>
            );
          })}
        </Box>
      ) : null}
    </Paper>
  );
};

export default FooterLinks;
